import { render, staticRenderFns } from "./ImportExportParam.vue?vue&type=template&id=31f43f20&scoped=true&"
import script from "./ImportExportParam.vue?vue&type=script&lang=js&"
export * from "./ImportExportParam.vue?vue&type=script&lang=js&"
import style0 from "./ImportExportParam.vue?vue&type=style&index=0&id=31f43f20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f43f20",
  null
  
)

export default component.exports